import './components/drawer';
import './components/cookie';
import './components/back-to-top';

import { _initGTM } from './utils';

window.dataLayer = window.dataLayer || [];
_initGTM();
